import { DefaultImage } from "@/lib/external-components"

export const getImageUrl = (imageUrl: any): string => {
  if (!imageUrl) return DefaultImage

  // Nếu là object, lấy url
  if (typeof imageUrl === "object" && imageUrl.url) {
    return imageUrl.url
  }

  // Nếu là string
  if (typeof imageUrl === "string") {
    return imageUrl
  }

  // Fallback
  return DefaultImage
}
